import React from "react";
import { Outlet } from "react-router-dom";

// Chat content now renders inside the app-wide AppShell (header + AppNav +
// ChatHistorySidebar). This Layout only provides the content container that
// fills the area AppShell hands it via its <Outlet/>; AppShell owns the
// header and the conversation-history sidebar. (The per-page Navbar mount is
// removed in a follow-up task.)
const Layout = () => {
  return (
    <div className="h-full w-full bg-background">
      <Outlet />
    </div>
  );
};

export default Layout;
